import React from 'react'
import Lottie from 'react-lottie'
import constants from '../../../constants'
import Text from '../../../components/Text'
import { useNavigate } from 'react-router-dom'

import anayaCareImgUrls from '../../../constants/anaya-constants'
import * as whatsAppAnimation from '../../../assets/animations/whats-app.json'
import useFetchDocuments from '../hooks/useFetchDocuments'
import UploadDocuments from '../Components/UploadDocuments'
import PageHeader from '../../../components/Layout/Header/PageHeader'
import AtomicLoader from '../../../components/Loader/AtomicLoader'
import UnderReviewCard from '../Components/UnderReviewCard'
import RejectedDocumentCard from '../Components/RejectedDocumentCard'
import Copyrights from '../../Programs/AnayaCare/Components/Copyrights'

const AnayaCareHome = () => {
  const navigate = useNavigate()
  const {
    documents: { loading, data },
    fetchDocuments,
  } = useFetchDocuments()
  const whatsAppAnimationOption = {
    loop: true,
    autoplay: true,
    animationData: whatsAppAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }
  const hasRejectedDocuments = data?.data?.some(
    (record) =>
      record.record_meta_info?.report_status === constants.REJECTED_STATUS,
  )

  const handleViewDocuments = () => {
    const qp = `support_program_type=${constants.CARE_PROGRAM_TYPE.ANAYA}`
    const url = `/care-plans/anaya-care/document-status?${qp}`
    navigate(url, { relative: `/care-plans/anaya-care?${qp}` })
  }

  if (loading) return <AtomicLoader show />
  if (!data?.data || data?.data?.length === 0) {
    return (
      <div>
        <PageHeader withBackBtn={false} pageTitle="Upload Documents" />
        <UploadDocuments onMoveNext={fetchDocuments} />
      </div>
    )
  }
  return (
    <div className="min-h-screen bg-white pb-4 px-5 space-y-8 max-w-md mx-auto">
      {/* Header */}
      <div className="bg-[#E1CFFF] rounded-b-[30px] py-8 space-y-7 -mx-5">
        <div className="px-4 mx-auto space-y-1">
          <img
            src={anayaCareImgUrls.anayaLogo}
            alt="Anaya Care Logo"
            className="h-11 w-40 mx-auto"
          />
          <img
            src={anayaCareImgUrls.documentView.header}
            alt="Anaya Care Logo"
          />
        </div>

        <div className="document-in-review-bg px-5">
          <img
            src={anayaCareImgUrls.documentView.sunflower}
            alt="Sunflower"
            className="w-[240px] h-[240px] max-w-[240px] max-h-[240px] mx-auto object-scale-down"
          />
          {/* Card: Care Specialist */}
          {hasRejectedDocuments ? (
            <RejectedDocumentCard onViewDocuments={handleViewDocuments} />
          ) : (
            <UnderReviewCard onViewDocuments={handleViewDocuments} />
          )}
        </div>
      </div>

      {/* What's Next Card */}
      <div className="rounded-[30px] next-card-bg overflow-hidden">
        <div className="flex w-full gap-3">
          <img
            src={anayaCareImgUrls.nurseImg}
            alt="Nurse"
            className="w-[150px] max-w-[150px] h-full rounded-xl object-cover mt-8"
          />
          <div className="py-14 space-y-2">
            <div className="flex items-center gap-2">
              {/* WhatsApp Animated icon */}
              <div className="min-w-6 max-w-6">
                <Lottie
                  speed={0.7}
                  options={whatsAppAnimationOption}
                  width={24}
                />
              </div>
              <Text
                tag="p"
                variant="title"
                size="large"
                className="text-[#1F2933]"
              >
                What's Next?
              </Text>
            </div>
            <Text
              tag="p"
              variant="body"
              size="large"
              className="text-[#3D4854] px-2"
            >
              We'll message you on WhatsApp once your details are approved by
              our Care Specialist. Thanks for your patience!
            </Text>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Copyrights />
    </div>
  )
}

export default AnayaCareHome
